import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper = new Swiper(".mySwiper", {
    slidesPerView: 4,
    spaceBetween: 14,
    watchSlidesProgress: true,
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        spaceBetween: 14,
        },
        768: {  //当屏幕宽度小于等于768
            slidesPerView: 4,
            spaceBetween: 10,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 2,
            spaceBetween: 10,
        }
    }
    
});
var swiper2 = new Swiper(".mySwiper2", {
    thumbs: {
        swiper: swiper,
    },
});

document.addEventListener('DOMContentLoaded', function() {
     
    // 初始化Swiper
    var swiper3 = new Swiper(".swiper3", {
        direction: "vertical",
        mousewheel: {
            enabled: true,
            releaseOnEdges: true, // 滚动到边缘时释放鼠标滚轮控制
            forceToAxis: true,    // 只允许纵向滚动
            invert: false,
            sensitivity: 1,
            eventsTarget: 'container'
        },
    });
});
var swiper = new Swiper(".section8 .swiper", {
    slidesPerView: 4,
    spaceBetween: 15,
    slidesPerGroup: 4,
    watchSlidesProgress: true,
    navigation: {
        nextEl: ".section8 .swiper-button-next",
        prevEl: ".section8 .swiper-button-prev",
    },
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        spaceBetween: 15,
        slidesPerGroup: 4,
        },
        768: {  //当屏幕宽度小于等于768
            slidesPerView: 3,
            spaceBetween: 15,
            slidesPerGroup: 3,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
        }
    }
    
});